import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import StandardThumb from '../../DeviationViews/Thumb/Standard';
import MeasuredTorpedo from '../MeasuredTorpedo';
import type {
  TorpedoLayoutedItem,
  ProGalleryContainer,
  TorpedoItem,
  TorpedoProps,
  TorpedoLayoutConfig,
} from '../types';
import { getDeviationEntityId } from '../../redux/normalizr/schemas/deviation';
import MediaService from '../../utils/DeviationMediaService';
import {
  Dims,
  MeasuredCookieConnectorOwnProps,
} from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

export interface DeviationTorpedoProps extends Partial<MeasuredCookieConnectorOwnProps> {
  container: ProGalleryContainer;
  items: PapiDeviation[];
  itemRenderer?: ItemRenderer;
  layoutConfig?: TorpedoLayoutConfig;
  contentStrip?: React.ReactNode;
  contentStripOffset?: number;
  maxRows?: number;
  hideIncompleteRows?: boolean;
  // Enables scroll optimisation where we only render what is
  // visible on screen.
  enableScrollVisibilityOptimisation?: boolean;
  defaultSize?: {
    desktop: Dims;
    mobile: Dims;
  };
}

export interface Item {
  id: string | number;
  width: number;
  height: number;
  deviation: PapiDeviation;
}

type ItemRenderer = (
  renderProps: TorpedoProps,
  item: TorpedoLayoutedItem<Item>,
  itemStyle: React.CSSProperties
) => React.ReactNode;

export const defaultItemRenderer: ItemRenderer = (renderProps, item, itemStyle) => (
  <StandardThumb
    key={`item-${item.idx}`}
    deviation={item.dto.deviation}
    width={item.width}
    height={item.height}
    style={itemStyle}
  />
);

const DeviationTorpedo: React.FC<DeviationTorpedoProps> = ({
  items: itemsFromProps,
  itemRenderer,
  ...torpedoProps
}) => {
  const items: TorpedoItem[] = itemsFromProps.map(item => {
    const largest = MediaService.getThumbDimensions(item);
    return {
      id: `deviation-${item.deviationId}`,
      width: largest.width!,
      height: largest.height!,
      deviation: item,
      duperbrowseItemId: getDeviationEntityId(item),
    };
  });

  return (
    <MeasuredTorpedo
      items={items}
      renderItem={itemRenderer || defaultItemRenderer}
      {...torpedoProps}
    />
  );
};
DeviationTorpedo.displayName = 'DeviationTorpedo';

export default DeviationTorpedo;
